<template>
  <div class="user-avatar-dropdown">
    <Dropdown style="line-height: 32px" @on-click="handleClick">
      <span>{{ userName }}({{ userAvatar }})</span>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="changePwd">修改密码</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <change-password-modal
      :model-value="areaWindowSelected"
      @changeModal="changeModal"
    />
  </div>
</template>

<script>
import './user.less';
import { mapActions } from 'vuex';
import { ChangePasswordModal } from '_c/change-password';
import { getUserType } from '@/libs/util';
export default {
  name: 'userControl',
  components: {
    ChangePasswordModal,
  },
  props: {
    userAvatar: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
    messageUnreadCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      areaWindowSelected: false,
    };
  },
  methods: {
    ...mapActions(['handleLogOut']),
    logout() {
      this.handleLogOut().then(() => {
        const userType = getUserType();
        if (userType === 'platform') {
          this.$router.push({
            name: 'loginPlatform',
          });
        } else if (userType === 'copartner') {
          this.$router.push({
            name: 'loginPartner',
          });
        } else {
          this.$router
            .replace({
              name: 'login',
            })
            .then(() => {
              // 在替换路由后，使用 window.location.reload() 强制刷新，确保没有历史记录
              window.location.reload();
            });
        }
      });
    },
    changePwd() {
      this.areaWindowSelected = true;
    },
    handleClick(name) {
      switch (name) {
        case 'logout':
          this.logout();
          break;
        case 'changePwd':
          this.changePwd();
          break;
      }
    },

    changeModal() {
      this.areaWindowSelected = false;
    },
  },
};
</script>
